module.exports = __webpack_public_path__ + "static/img/zuodengnisi_icon.4fcf3de.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/zuodengnisi_icon.png
// module id = IGJZ
// module chunks = 1